import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, Button } from "@material-ui/core";
import {
  OutlinedInput,
  ListItemText,
  TextField,
  Select,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { useSelector } from "react-redux";
import * as env from "../utils/EnvVars";
import TopicName from "../components/TopicName";
import KeywordName from "../components/KeywordName";
import GradeName from "../components/GradeName";
import DifficultyName from "../components/DifficultyName";
import ExamType from "../components/ExamType";
import Country from "../components/Country";
import Tags from "../components/Tags";
import Language from "../components/Language";

import { Table, TableContainer, TableCell, TableRow } from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical = "top",
  horizontal = "center";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const userObj = useSelector((state) => state.userDetails);
  const [open, setOpen] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);

  const alphaArr = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  const [rows, setRows] = React.useState([]);

  const [questionTypeId, setQuestionTypeId] = React.useState(8);
  const [questionTypeName, setQuestionTypeName] =
    React.useState("MR Matching Type");

  const [templateTitle, setTemplateTitle] = React.useState("");
  const [treeviewTemplateId, setTreeviewTemplateId] = React.useState(0);
  const [treeviewTemplateTitle, setTreeviewTemplateTitle] = React.useState("");
  const [selftestOptionsObjectiveId, setSelftestOptionsObjectiveId] =
    React.useState(0);
  const [selftestOptionsObjectiveTitle, setSelftestOptionsObjectiveTitle] =
    React.useState("");
  const [selftestOptionsSubjectiveId, setSelftestOptionsSubjectiveId] =
    React.useState(0);
  const [selftestOptionsSubjectiveTitle, setSelftestOptionsSubjectiveTitle] =
    React.useState("");
  const [examLimitId, setExamLimitId] = React.useState(0);
  const [examLimitTitle, setExamLimitTitle] = React.useState("");
  const [objectiveQueTypeTempId, setObjectiveQueTypeTempId] = React.useState(0);
  const [objectiveQueTypeTempTitle, setObjectiveQueTypeTempTitle] =
    React.useState("");
  const [subjectiveQueTypeTempId, setSubjectiveQueTypeTempId] =
    React.useState(0);
  const [subjectiveQueTypeTempTitle, setSubjectiveQueTypeTempTitle] =
    React.useState("");
  const [mocktestTemplateId, setMocktestTemplateId] = React.useState(0);
  const [mocktestTemplateTitle, setMocktestTemplateTitle] = React.useState("");
  const [topictestTemplateId, setTopictestTemplateId] = React.useState(0);
  const [topictestTemplateTitle, setTopictestTemplateTitle] =
    React.useState("");

  const [treeviewTemplateList, setTreeviewTemplateList] = React.useState([]);
  const [selftestOptionsObjectiveList, setSelftestOptionsObjectiveList] =
    React.useState([]);
  const [selftestOptionsSubjectiveList, setSelftestOptionsSubjectiveList] =
    React.useState([]);
  const [examLimitList, setExamLimitList] = React.useState([]);
  const [objectiveQueTypeTempList, setObjectiveQueTypeTempList] =
    React.useState([]);
  const [subjectiveQueTypeTempList, setSubjectiveQueTypeTempList] =
    React.useState([]);
  const [mocktestTemplateList, setMocktestTemplateList] = React.useState([]);
  const [topictestTemplateList, setTopictestTemplateList] = React.useState([]);
  const [questionBody, setQuestionBody] = useState("");
  const [leftHeader, setLeftHeader] = useState("");
  const [rightHeader, setRightHeader] = useState("");

  const [topicList, setTopicList] = useState([]);
  const [topicId, setTopicId] = useState(0);
  const [topicName, setTopicName] = useState("");
  const [examType, setExamType] = useState("");
  const [gradeList, setGradeList] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeId, setGradeId] = useState(0);
  const [difficultyList, setDifficultyList] = useState([]);
  const [difficultyName, setDifficultyName] = useState("");
  const [difficultyId, setDifficultyId] = useState(0);
  const [languageList, setLanguageList] = useState([]);
  const [languageName, setLanguageName] = useState("");
  const [languageId, setLanguageId] = useState(0);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState("");
  const [countryId, setCountryId] = useState(0);
  const [explanation, setExplanation] = useState("");
  const [tags, setTags] = useState([]);
  const [keyword, setKeyword] = useState([]);
  const [formattedKeyword, setFormattedKeyword] = useState("");
  const [personName, setPersonName] = React.useState([]);
  const [formattedTags, setFormattedTags] = useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert() {
    setShowAlert(false);
  }

  // handle Change for the dropdowns

  const handleTopicChange = (selectedTopic) => {
    if (selectedTopic === null) {
      setTopicId(0);
      setTopicName("");
    }
    setTopicId(selectedTopic?.topicId || 0);
    setTopicName(selectedTopic?.topicName || "");
  };

  const handleGrade = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  };

  const handleDifficulty = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    console.log(valArr);
    setDifficultyId(valArr[0]);
    setDifficultyName(valArr[1]);
  };

  const handleLanguageChange = (event) => {
    setLanguageName(event.target.value);
  };

  const handleCountryChange = (event) => {
    setCountryName(event.target.value);
  };

  const handleExamTypeChange = (event) => {
    setExamType(event.target.value);
  };

  const handleKeywordChange = (event, selectedTags) => {
    setKeyword(selectedTags);
    setFormattedKeyword(selectedTags.join(","));
  };

  const handleTagChange = (event, selectedTags) => {
    setTags(selectedTags);
    setFormattedTags(selectedTags.join(","));
  };

  const rowHeaders = Array.from(
    new Set(
      rows
        ?.filter((item) => item.leftHeaderText)
        ?.map((item) => item.leftHeaderId)
    )
  );
  const columnHeaders = Array.from(
    new Set(
      rows
        ?.filter((item) => item.rightHeaderText)
        ?.map((item) => item.rightHeaderId)
    )
  );

  console.log(rowHeaders, columnHeaders, "headers");

  React.useEffect(() => {
    setRows([]);
    // if (open && userObj) {
    //   createOption(7);
    // }
    if (open) {
      createOption(8);
      getData();
    }

    // if (open && props.dataObj && props.dataObj.autoId) {
    //   setTemplateTitle(props.dataObj.templateTitle);
    //   setTreeviewTemplateId(props.dataObj.treeviewTemplateId);
    //   setTreeviewTemplateTitle(props.dataObj.treeviewTemplateTitle);
    //   setSelftestOptionsObjectiveId(props.dataObj.selftestOptionsObjectiveId);
    //   setSelftestOptionsObjectiveTitle(
    //     props.dataObj.selftestOptionsObjectiveTitle
    //   );
    //   setSelftestOptionsSubjectiveId(props.dataObj.selftestOptionsSubjectiveId);
    //   setSelftestOptionsSubjectiveTitle(
    //     props.dataObj.selftestOptionsSubjectiveTitle
    //   );
    //   setExamLimitId(props.dataObj.examLimitId);
    //   setExamLimitTitle(props.dataObj.examLimitTitle);
    //   setObjectiveQueTypeTempId(props.dataObj.objectiveQueTypeTempId);
    //   setObjectiveQueTypeTempTitle(props.dataObj.objectiveQueTypeTempTitle);
    //   setSubjectiveQueTypeTempId(props.dataObj.subjectiveQueTypeTempId);
    //   setSubjectiveQueTypeTempTitle(props.dataObj.subjectiveQueTypeTempTitle);
    //   setMocktestTemplateId(props.dataObj.mocktestTemplateId);
    //   setMocktestTemplateTitle(props.dataObj.mocktestTemplateTitle);
    //   setTopictestTemplateId(props.dataObj.topictestTemplateId);
    //   setTopictestTemplateTitle(props.dataObj.topictestTemplateTitle);
    // } else {
    //   setQuestionType(8);

    //   setTemplateTitle("");
    //   setTreeviewTemplateId(0);
    //   setTreeviewTemplateTitle("");
    //   setSelftestOptionsObjectiveId(0);
    //   setSelftestOptionsObjectiveTitle("");
    //   setSelftestOptionsSubjectiveId(0);
    //   setSelftestOptionsSubjectiveTitle("");
    //   setExamLimitId(0);
    //   setExamLimitTitle("");
    //   setObjectiveQueTypeTempId(0);
    //   setObjectiveQueTypeTempTitle("");
    //   setSubjectiveQueTypeTempId(0);
    //   setSubjectiveQueTypeTempTitle("");
    //   setMocktestTemplateId(0);
    //   setMocktestTemplateTitle("");
    //   setTopictestTemplateId(0);
    //   setTopictestTemplateTitle("");
    // }

    if (open && props.dataObj && props.dataObj.autoId) {
      setQuestionTypeId(props.dataObj.questionTypeId);
      setQuestionBody(props.dataObj.questionBankSet.questionBody);
      setQuestionTypeName(props.dataObj.questionBankSet.questionType);
      setGradeId(props.dataObj.gradeId);
      setGradeName(props.dataObj.gradeName);
      setTopicId(props.dataObj.topicId);
      setTopicName(props.dataObj.topicName);
      setDifficultyId(props.dataObj.difficultyId);
      setDifficultyName(props.dataObj.difficultyName);
      setExamType(props.dataObj.examType);
      setLanguageName(props.dataObj.language);
      setCountryName(props.dataObj.country);
      const TagsArray = props.dataObj.tags
        .split(",")
        .filter((tag) => tag.trim() !== "");
      setTags(TagsArray);
      setFormattedTags(props.dataObj.tags);
      const keywordsArray = props.dataObj.keywordNames
        .split(",")
        .filter((keyword) => keyword.trim() !== "");
      setKeyword(keywordsArray);
      setFormattedKeyword(props.dataObj.keywordNames);
      setLeftHeader(props.dataObj.questionBankSet.columns[0].columnHeader);
      setRightHeader(props.dataObj.questionBankSet.columns[1].columnHeader);
      const leftColumn =
        props.dataObj?.questionBankSet?.columns[0]?.columnRows.map((el) => ({
          leftHeaderId: el.rowId,
          leftHeaderText: el.rowName,
        }));
      const rightColumn =
        props.dataObj?.questionBankSet?.columns[1]?.columnRows.map((el) => ({
          rightHeaderId: el.rowId,
          rightHeaderText: el.rowName,
        }));
      const combinedRows = leftColumn.map((leftRow, index) => ({
        ...leftRow,
        ...rightColumn[index],
      }));
      setRows(combinedRows);
      setPersonName(props.dataObj?.questionBankSet?.correctResponse.split("~"));
      setExplanation(props.dataObj?.questionBankSet?.explanations);
    } else {
      setQuestionTypeId(8);
      setQuestionTypeName("MR Matching Type");
      setQuestionBody("");
      setExamType("");
      setExplanation("");
      setTopicId(0);
      setTopicName("");
      setKeyword([]);
      setGradeId(0);
      setGradeName("");
      setDifficultyId(0);
      setDifficultyName("");
      setLanguageName("");
      setCountryName("");
      setTags([]);
    }
  }, [props.dataObj, open]);

  console.log(props.dataObj, "dataObjjj");

  const getData = async () => {
    try {
      let endpoint1 = env.API_KEY + "/topics-list";
      let endpoint2 = env.API_KEY + "/languages-list";
      let endpoint3 = env.API_KEY + "/country-list";
      let endpoint4 = env.API_KEY + "/difficulty-list";
      let endpoint5 = env.API_KEY + "/grades-list";

      const axiosrequest1 = axios.get(endpoint1);
      const axiosrequest2 = axios.get(endpoint2);
      const axiosrequest3 = axios.get(endpoint3);
      const axiosrequest4 = axios.get(endpoint4);
      const axiosrequest5 = axios.get(endpoint5);

      let [response1, response2, response3, response4, response5] =
        await axios.all([
          axiosrequest1,
          axiosrequest2,
          axiosrequest3,
          axiosrequest4,
          axiosrequest5,
        ]);
      setTopicList(response1?.data?.obj);
      setLanguageList(response2?.data?.obj);
      setCountryList(response3?.data?.obj);
      setDifficultyList(response4?.data?.obj);
      setGradeList(response5?.data?.obj);
    } catch (error) {
      console.log("error");
    }
  };

  console.log(rows, "rows");

  async function getApiData() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: userObj.loginId,
        token: userObj.token,
        device: "web",
      },
    };
    let endpoints1 =
      env.API_EXAM_SERVICE +
      "/topic-service/read/topics-templates?sortby=templateName&maxRows=50000";
    let endpoints2 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints3 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints4 =
      env.API_EXAM_SERVICE +
      "/exams/read/exam-limits-templates?sortby=templateTitle&maxRows=50000";
    let endpoints5 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints6 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints7 =
      env.API_EXAM_SERVICE +
      "/exams/read/mocktest-templates?sortby=templateTitle&maxRows=50000";
    let endpoints8 =
      env.API_EXAM_SERVICE +
      "/exams/read/topictest-templates?sortby=templateTitle&maxRows=50000";

    const axiosrequest1 = axios.get(endpoints1, axiosHeader);
    const axiosrequest2 = axios.get(endpoints2, axiosHeader);
    const axiosrequest3 = axios.get(endpoints3, axiosHeader);
    const axiosrequest4 = axios.get(endpoints4, axiosHeader);
    const axiosrequest5 = axios.get(endpoints5, axiosHeader);
    const axiosrequest6 = axios.get(endpoints6, axiosHeader);
    const axiosrequest7 = axios.get(endpoints7, axiosHeader);
    const axiosrequest8 = axios.get(endpoints8, axiosHeader);

    await axios
      .all([
        axiosrequest1,
        axiosrequest2,
        axiosrequest3,
        axiosrequest4,
        axiosrequest5,
        axiosrequest6,
        axiosrequest7,
        axiosrequest8,
      ])
      .then(
        axios.spread(function (res1, res2, res3, res4, res5, res6, res7, res8) {
          setTreeviewTemplateList(res1.data.list);
          setSelftestOptionsObjectiveList(res2.data.list);
          setSelftestOptionsSubjectiveList(res3.data.list);
          setExamLimitList(res4.data.list);
          setObjectiveQueTypeTempList(res5.data.list);
          setSubjectiveQueTypeTempList(res6.data.list);
          setMocktestTemplateList(res7.data.list);
          setTopictestTemplateList(res8.data.list);
        })
      );
  }

  //Post API
  const columns = [
    {
      columnHeader: leftHeader,
      columnRows: leftHeader
        ? rows.map((row, i) => ({
            rowId: row?.leftHeaderId,
            rowName: row?.leftHeaderText,
          }))
        : [],
    },
    {
      columnHeader: rightHeader,
      columnRows: rightHeader
        ? rows.map((row, i) => ({
            rowId: row?.rightHeaderId,
            rowName: row?.rightHeaderText,
          }))
        : [],
    },
  ];

  const responseChoice = [];

  rows.forEach((left, leftIndex) => {
    rows.forEach((right, rightIndex) => {
      const responseText = `${left.leftHeaderId}-(${right.rightHeaderId})`;
      responseChoice.push({
        responseId: String.fromCharCode(
          65 + leftIndex * rows.length + rightIndex
        ),
        responseText,
      });
    });
  });

  let questionJson = {
    questionType: "MR Matching Type",
    commonDataDescription: null,
    questionBody: questionBody,
    columns: columns,
    responseChoiceShuffle: "No",
    responseChoice: responseChoice,
    correctResponse: personName.join("~"),
    explanations: explanation,
  };

  function handleSave() {
    if (!questionBody) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter question");
      return false;
    } else if (!leftHeader) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter left Header");
      return false;
    } else if (!rightHeader) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter right Header");
      return false;
    } else if (!topicName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Topic");
      return false;
    } else if (!gradeName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Grade Name");
      return false;
    } else if (!examType) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Exam Type");
      return false;
    } else if (!languageName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select language");
      return false;
    }

    if (
      questionBody &&
      questionBody.length > 1 &&
      leftHeader &&
      rightHeader &&
      topicName &&
      gradeName &&
      examType &&
      languageName
    ) {
      setSaveLoading(true);

      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          // loginId: userObj.loginId,
          // token: userObj.token,
          // device: "web",
        },
      };
      const data = new FormData();
      if (props.dataObj && props.dataObj.autoId) {
        data.append("id", props.dataObj.autoId);
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", questionTypeName);
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      } else {
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", questionTypeName);
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      }
      // private String commonDataDescription;
      // private String questionBody;
      // private List<BeanColumns> columns;
      // private List<BeanResponseChoice> answerOption;
      // private Boolean answerOptionShuffle;
      // private String correctAnswer;
      // private String explanation;

      //let questionJson = {'commonDataDescription':'','questionBody':questionBody, 'columns':rows, 'answerOption':rows, 'answerOptionShuffle':'', 'correctAnswer':correctAnswer, 'explanation':explanation};

      // data.append("answerOption", JSON.stringify(rows));
      // data.append("correctAnswer", correctAnswer);
      // data.append("explanation", explanation);

      // if (shuffle) {
      //   data.append("shuffle", 1);
      // } else {
      //   data.append("shuffle", 0);
      // }

      let apiURL = "/admin-questionbanks-create";
      let myMessage = "Question has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/admin-questionbanks-update";
        myMessage = "Question has been updated.";
      }

      // return;

      axios
        .post(env.API_KEY + apiURL, data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            props.updatedList(response.data.list);
            window.location.reload();
            return false;
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  function saveData() {
    if (!templateTitle) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter exam title");
      return false;
    }

    if (templateTitle && templateTitle.length > 1) {
      setSaveLoading(true);

      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          loginId: userObj.loginId,
          token: userObj.token,
          device: "web",
        },
      };
      const data = new FormData();
      if (props.dataObj && props.dataObj.autoId) {
        data.append("id", props.dataObj.autoId);
      }
      data.append("templateTitle", templateTitle);
      data.append("treeviewTemplateId", treeviewTemplateId);
      data.append("treeviewTemplateTitle", treeviewTemplateTitle);
      data.append("selftestOptionsObjectiveId", selftestOptionsObjectiveId);
      data.append(
        "selftestOptionsObjectiveTitle",
        selftestOptionsObjectiveTitle
      );
      data.append("selftestOptionsSubjectiveId", selftestOptionsSubjectiveId);
      data.append(
        "selftestOptionsSubjectiveTitle",
        selftestOptionsSubjectiveTitle
      );
      data.append("examLimitId", examLimitId);
      data.append("examLimitTitle", examLimitTitle);
      data.append("objectiveQueTypeTempId", objectiveQueTypeTempId);
      data.append("objectiveQueTypeTempTitle", objectiveQueTypeTempTitle);
      data.append("subjectiveQueTypeTempId", subjectiveQueTypeTempId);
      data.append("subjectiveQueTypeTempTitle", subjectiveQueTypeTempTitle);
      data.append("mocktestTemplateId", mocktestTemplateId);
      data.append("mocktestTemplateTitle", mocktestTemplateTitle);
      data.append("topictestTemplateId", topictestTemplateId);
      data.append("topictestTemplateTitle", topictestTemplateTitle);

      let apiURL = "/exams/create/exam-templates";
      let myMessage = "Template name has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/exams/update/exam-templates";
        myMessage = "Template name has been updated.";
      }

      axios
        .post(env.API_EXAM_SERVICE + apiURL, data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            props.updatedList(response.data.list);
            return false;
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  function handleTreeview(val) {
    let valArr = val.split("#");
    setTreeviewTemplateId(valArr[0]);
    setTreeviewTemplateTitle(valArr[1]);
  }
  function handleSelftestOptionsObjective(val) {
    let valArr = val.split("#");
    setSelftestOptionsObjectiveId(valArr[0]);
    setSelftestOptionsObjectiveTitle(valArr[1]);
  }
  function handleSelftestOptionsSubjective(val) {
    let valArr = val.split("#");
    setSelftestOptionsSubjectiveId(valArr[0]);
    setSelftestOptionsSubjectiveTitle(valArr[1]);
  }
  function handleExamLimit(val) {
    let valArr = val.split("#");
    setExamLimitId(valArr[0]);
    setExamLimitTitle(valArr[1]);
  }
  function handleObjectiveQueTypeTemp(val) {
    let valArr = val.split("#");
    setObjectiveQueTypeTempId(valArr[0]);
    setObjectiveQueTypeTempTitle(valArr[1]);
  }
  function handleSubjectiveQueTypeTemp(val) {
    let valArr = val.split("#");
    setSubjectiveQueTypeTempId(valArr[0]);
    setSubjectiveQueTypeTempTitle(valArr[1]);
  }
  function handleMocktestTemplate(val) {
    let valArr = val.split("#");
    setMocktestTemplateId(valArr[0]);
    setMocktestTemplateTitle(valArr[1]);
  }
  function handleTopictestTemplate(val) {
    let valArr = val.split("#");
    setTopictestTemplateId(valArr[0]);
    setTopictestTemplateTitle(valArr[1]);
  }

  const handleAnswerOption = (i, e, isLeft) => {
    const { value } = e?.target;
    setRows((prev) => {
      const updatedState = [...prev];
      updatedState[i] = {
        ...updatedState[i],
        [isLeft ? "leftHeaderId" : "rightHeaderId"]: isLeft
          ? alphaArr[i]
          : alphaArr[i + 15],
        [isLeft ? "leftHeaderText" : "rightHeaderText"]: value,
      };
      return updatedState;
    });
  };

  const addTableRows = () => {
    const rowsInput = {
      leftHeaderId: "",
      leftHeaderText: "",
      rightHeaderId: "",
      rightHeaderText: "",
    };
    setRows([...rows, rowsInput]);
  };

  console.log(rows, "rows664");

  function createOption(opt) {
    console.log(opt, "optttttttt");
    const rowsInput = {
      leftHeaderId: "",
      leftHeaderText: "",
      rightHeaderId: "",
      rightHeaderText: "",
    };
    let optArr = [];
    if (8 === opt) {
      for (let i = 0; i < 4; i++) {
        optArr.push(rowsInput);
      }
    }
    setRows(optArr);
  }

  function handleQuestionType(val) {
    setQuestionTypeId(val);
    createOption(val);
  }

  const handleChange = (event) => {
    console.log(event, "event===>>>");
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <>
      <Dialog
        disableEnforceFocus
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <DialogContent>
          <Box style={{ display: "flex" }}>
            <Grid item md={6} xs={6} className="test-instructions">
              <div className="btmbdrgry">
                <h3>
                  {props.dataObj != null ? <>Edit</> : <>New</>} MRMT Question
                </h3>
              </div>

              <Box mt={1}>
                <TextField
                  label="Question Body"
                  onChange={(event) => setQuestionBody(event.target.value)}
                  value={questionBody}
                  sx={{ fontSize: 10 }}
                  rows={3}
                  multiline
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </Box>

              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      label="Left Header"
                      onChange={(event) => setLeftHeader(event.target.value)}
                      value={leftHeader}
                      sx={{ fontSize: 10 }}
                      size="small"
                      variant="outlined"
                      fullWidth
                    />

                    {rows && rows.length > 0
                      ? rows.map((row, i) => (
                          <TextField
                            label="Option"
                            onChange={(event) =>
                              handleAnswerOption(i, event, true)
                            }
                            value={row?.leftHeaderText}
                            sx={{ fontSize: 10, marginTop: 1 }}
                            size="small"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div>{alphaArr[i]}</div>
                                </InputAdornment>
                              ),
                            }}
                          />
                        ))
                      : null}
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Right Header"
                      onChange={(event) => setRightHeader(event.target.value)}
                      value={rightHeader}
                      sx={{ fontSize: 10 }}
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                    {rows && rows.length > 0
                      ? rows.map((row, i) => (
                          <TextField
                            label="Option"
                            onChange={(event) =>
                              handleAnswerOption(i, event, false)
                            }
                            value={row?.rightHeaderText}
                            sx={{ fontSize: 10, marginTop: 1 }}
                            size="small"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div>{alphaArr[i + 15]}</div>
                                </InputAdornment>
                              ),
                            }}
                          />
                        ))
                      : null}
                  </Grid>
                </Grid>
              </Box>
              {rows && rows.length < 11 ? (
                <Box mt={1}>
                  <Button
                    onClick={() => {
                      addTableRows();
                    }}
                    style={{ textTransform: "none" }}
                    size="small"
                    variant="outlined"
                  >
                    Add Option
                  </Button>
                </Box>
              ) : null}

              <Box mt={1}>
                <FormControl fullWidth size="small" style={{ marginTop: 2 }}>
                  <InputLabel id="demo-multiple-checkbox-label">
                    Correct Answer
                  </InputLabel>
                  {/* <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Correct Answer" />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {rows && rows.length > 0
                      ? rows.map((rowx, i) =>
                          rows.map((rowy, j) => (
                            <MenuItem
                              key={"a" + i}
                              value={alphaArr[i] + "-" + alphaArr[j + 15]}
                            >
                              <Checkbox
                                checked={
                                  personName.indexOf(
                                    alphaArr[i] + "-" + alphaArr[j + 15]
                                  ) > -1
                                }
                              />
                              <ListItemText
                                primary={alphaArr[i] + "-" + alphaArr[j + 15]}
                              />
                            </MenuItem>
                          ))
                        )
                      : null}
                  </Select> */}
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Correct Answer" />}
                    renderValue={(selected) => selected.sort().join(", ")}
                    MenuProps={MenuProps}
                  >
                    {rows && rows.length > 0
                      ? rows.map((rowx, i) =>
                          rows.map((rowy, j) => {
                            // Calculate the index and convert it into alphabetical order
                            const index = i * rows.length + j;
                            const alphabetIndex =
                              index < 26
                                ? String.fromCharCode(65 + index)
                                : null;
                            return (
                              <MenuItem
                                key={"a" + i}
                                value={
                                  alphabetIndex !== null ? alphabetIndex : ""
                                }
                              >
                                <Checkbox
                                  checked={
                                    personName.indexOf(alphabetIndex) > -1
                                  }
                                />
                                <ListItemText
                                  primary={alphaArr[i] + "-" + alphaArr[j + 15]}
                                />
                              </MenuItem>
                            );
                          })
                        )
                      : null}
                  </Select>
                </FormControl>

                <TextField
                  label="Explanation"
                  onChange={(event) => setExplanation(event.target.value)}
                  value={explanation}
                  sx={{ fontSize: 10, marginTop: 1 }}
                  rows={3}
                  multiline
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </Box>
              <Box mt={1.5}>
                <TopicName
                  topicList={topicList}
                  handleTopicChange={handleTopicChange}
                  topicName={topicName}
                  topicId={topicId}
                />
              </Box>
              <Box mt={1.5}>
                <KeywordName
                  handleKeywordChange={handleKeywordChange}
                  keyword={keyword}
                />
              </Box>
              <Box mt={1.5}>
                <GradeName
                  gradeName={gradeName}
                  handleGrade={handleGrade}
                  gradeList={gradeList}
                  gradeId={gradeId}
                />
              </Box>
              <Box mt={1.5}>
                <DifficultyName
                  difficultyName={difficultyName}
                  handleDifficulty={handleDifficulty}
                  difficultyList={difficultyList}
                  difficultyId={difficultyId}
                />
              </Box>
              <Box mt={1.5}>
                <ExamType
                  examType={examType}
                  handleExamTypeChange={handleExamTypeChange}
                />
              </Box>
              <Box mt={1.5}>
                <Language
                  languageName={languageName}
                  handleLanguageChange={handleLanguageChange}
                  languageList={languageList}
                  languageId={languageId}
                />
              </Box>
              <Box mt={1.5}>
                <Country
                  countryName={countryName}
                  handleCountryChange={handleCountryChange}
                  countryList={countryList}
                  countryId={countryId}
                />
              </Box>
              <Box mt={1.5}>
                <Tags handleTagChange={handleTagChange} tag={tags} />
              </Box>
              <Box mt={2}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  style={{ marginRight: 12 }}
                  size="small"
                  variant="outlined"
                >
                  Cancel
                </Button>
                {saveLoading ? (
                  <LoadingButton
                    loading={saveLoading}
                    style={{
                      backgroundColor: "#008000",
                      color: "#FFF",
                      marginRight: 10,
                    }}
                    size="small"
                    variant="contained"
                  >
                    Save
                  </LoadingButton>
                ) : (
                  <Button
                    onClick={() => {
                      // saveData();
                      handleSave();
                    }}
                    style={{
                      backgroundColor: "#008000",
                      color: "#FFF",
                      marginRight: 10,
                    }}
                    size="small"
                    variant="contained"
                  >
                    Save
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid item md={6} xs={6} spacing={1}>
              <div>
                <div className="btmbdrgry">
                  <h2 style={{ marginLeft: "20px" }}>Preview</h2>
                </div>
                <Box sx={{ marginTop: "20px", marginLeft: "20px" }}>
                  <h4>{questionBody ? "Q." + " " + questionBody : ""}</h4>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Grid
                    item
                    md={6}
                    xs={6}
                    spacing={1}
                    sx={{ marginLeft: "5px" }}
                  >
                    <h4 style={{ marginLeft: "20px" }}>{leftHeader}</h4>
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: 0,
                        marginLeft: "10px",
                      }}
                    >
                      {rows?.map((el, i) => (
                        <li key={i}>
                          {el.leftHeaderText && (
                            <>
                              <Typography
                                component="span"
                                style={{ marginRight: "5px" }}
                              >
                                {alphaArr[i] + " . "}
                              </Typography>
                            </>
                          )}
                          {el.leftHeaderText}
                        </li>
                      ))}
                    </ul>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    spacing={1}
                    sx={{ marginLeft: "5px" }}
                  >
                    <h4>{rightHeader}</h4>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                      {rows?.map((el, i) => (
                        <li key={i}>
                          {el.rightHeaderText && (
                            <>
                              <Typography
                                component="span"
                                style={{ marginRight: "5px" }}
                              >
                                {alphaArr[i + 15] + " . "}
                              </Typography>
                            </>
                          )}
                          {el.rightHeaderText}
                        </li>
                      ))}
                    </ul>
                  </Grid>
                  <br />
                </Box>
                {/* <Box sx={{ marginLeft: "30px" }}></Box> */}
                {/* {rowHeaders.length > 1 && columnHeaders.length > 1 && (
                  <div style={{ overflowX: "auto" }}>
                    <TableContainer
                      style={{
                        width: "50%",
                        marginLeft: "30px",
                        marginTop: "10px",
                      }}
                    >
                      <Table>
                        <TableRow>
                          <TableCell></TableCell>
                          {columnHeaders.map((column) => (
                            <TableCell key={column} style={{ padding: "5px" }}>
                              {column}
                            </TableCell>
                          ))}
                        </TableRow>
                        {rowHeaders.map((rowHeader) => (
                          <TableRow key={rowHeader}>
                            <TableCell style={{ padding: "5px" }}>
                              {rowHeader}
                            </TableCell>
                            {columnHeaders.map((columnHeader) => {
                              const cellData = rows.find(
                                (item) =>
                                  item.leftHeaderId === rowHeader &&
                                  item.rightHeaderId === columnHeader
                              );
                              return (
                                <TableCell
                                  key={columnHeader}
                                  style={{ padding: 0 }}
                                >
                                  <Checkbox />
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))}
                      </Table>
                    </TableContainer>
                  </div>
                )} */}
                {rowHeaders.length > 1 && columnHeaders.length > 1 && (
                  <div
                    style={{
                      overflowX: "auto",
                      width: "50%",
                      marginLeft: "30px",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: `auto ${"auto ".repeat(
                          columnHeaders.length
                        )}`,
                      }}
                    >
                      <div></div> {/* Placeholder for top left corner */}
                      {columnHeaders.map((column, index) => (
                        <div key={index} style={{ padding: "5px" }}>
                          {column}
                        </div>
                      ))}
                      {rowHeaders.map((rowHeader, rowIndex) => (
                        <React.Fragment key={rowIndex}>
                          <div style={{ padding: "5px" }}>{rowHeader}</div>
                          {columnHeaders.map((columnHeader, colIndex) => {
                            const cellData = rows.find(
                              (item) =>
                                item.leftHeaderId === rowHeader &&
                                item.rightHeaderId === columnHeader
                            );
                            return (
                              <div
                                key={`${rowIndex}-${colIndex}`}
                                style={{
                                  padding: 0,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Checkbox />
                              </div>
                            );
                          })}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                )}

                <br />
                <Box sx={{ marginLeft: "20px" }}>
                  {personName.length > 0 && (
                    <Typography component="span">
                      <span sx={{ fontWeight: "bold" }}>
                        <strong>Correct Answer :</strong>
                      </span>{" "}
                      {personName?.map((el) => " " + el)}
                    </Typography>
                  )}
                  <br />
                  {explanation && (
                    <Typography component="span">
                      <span sx={{ fontWeight: "bold" }}>
                        <strong>Explanation :</strong>
                      </span>{" "}
                      {explanation}
                    </Typography>
                  )}
                </Box>
              </div>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={hideAlert}
            variant="filled"
            severity={severityAlert}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
});

export default CustomizedDialogs;
